jQuery(document).ready(function($) {
    
	$('.hamburger__open').click(function(e) {
		e.preventDefault();
		$('#hamburger-nav').addClass('active');
	});
    
	$('.hamburger__close').click(function(e) {
		e.preventDefault();
		$('#hamburger-nav').removeClass('active');
	});
 
});
